import { BillingDashboardPanel } from "./BillingDashboardPanel";
import { FinancialDashboardPanel } from "./FinancialDashboardPanel";

export function DashboardView() {
  return (
    <div className="h-full overflow-auto bg-background">
      <div
        className="bg-card border-b border-border px-4 md:px-6"
        style={{
          paddingTop: "var(--spacing-page-header-top)",
          paddingBottom: "var(--spacing-page-header-bottom)",
        }}
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h1
              className="text-foreground"
              style={{
                fontSize: "var(--text-page-title)",
                fontWeight: "var(--font-weight-semi-bold)",
                lineHeight: "1.3",
              }}
            >
              Dashboard
            </h1>
            <p
              style={{
                fontSize: "var(--text-base)",
                marginTop: "var(--spacing-title-subtitle)",
                color: "var(--subtitle-text)",
              }}
            >
              Visão operacional do dia
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 md:px-6 py-6 md:py-8 space-y-8">
        <BillingDashboardPanel />
        <FinancialDashboardPanel />
      </div>
    </div>
  );
}
